export default {
  unknown: 'Unknown',
  multipleMatches: 'Multiple matches',
  anonymous: 'Anonymous',
  none: 'None',
} as const;
